export default __webpack_public_path__ + "static/media/icon_user_settings.5bddc71d.svg";